import { Injectable } from "@angular/core";
import { PdaConfiguration } from "../pda-configuration";
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { tap } from "rxjs/operators";
import { ServicePathsSettings } from "src/app/core/configuration/service-paths-settings";

@Injectable({
    providedIn: 'root'
})
export class PdaConfigurationService {

    pdaConfiguration: PdaConfiguration;

    constructor(private http: HttpClient) {

    }

    getConfigurationProperties(): Observable<any> {
        return this.http.get<PdaConfiguration>(
            ServicePathsSettings.URL_PDA_CONFIGURATION
        )
            .pipe(
                tap(it =>
                    this.pdaConfiguration = it
                )
            )
    }

    getBaseUrl() {
        return this.pdaConfiguration?.pdaBaseUrl;
    }

    getAuthUrl() {
        return this.pdaConfiguration?.pdaAuthUrl;
    }

}